export const stripSvgForeignObjects = async (file: File): Promise<File> => {
	const text = await file.text()
	const parser = new DOMParser()
	const doc = parser.parseFromString(text, 'image/svg+xml')
	const foreignObjects = doc.querySelectorAll('foreignObject')
	if (foreignObjects.length === 0) return file
	foreignObjects.forEach((el) => el.remove())
	const serialized = new XMLSerializer().serializeToString(doc.documentElement)
	return new File([serialized], file.name, { type: file.type })
}
